/* tslint:disable */
/* eslint-disable */
/* @relayHash a0240b387f7729780ee591b1d2736dae */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type STORY_MODE = "COMMENTS" | "QA" | "RATINGS_AND_REVIEWS" | "%future added value";
export type StreamQueryVariables = {
    storyID?: string | null;
    storyURL?: string | null;
    storyMode?: STORY_MODE | null;
};
export type StreamQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"StreamContainer_viewer">;
    } | null;
    readonly story: {
        readonly " $fragmentRefs": FragmentRefs<"StreamContainer_story">;
    } | null;
    readonly settings: {
        readonly " $fragmentRefs": FragmentRefs<"StreamContainer_settings">;
    };
};
export type StreamQuery = {
    readonly response: StreamQueryResponse;
    readonly variables: StreamQueryVariables;
};



/*
query StreamQuery(
  $storyID: ID
  $storyURL: String
  $storyMode: STORY_MODE
) {
  viewer {
    ...StreamContainer_viewer
    id
  }
  story: stream(id: $storyID, url: $storyURL, mode: $storyMode) {
    ...StreamContainer_story
    id
  }
  settings {
    ...StreamContainer_settings
    id
  }
}

fragment AnnouncementContainer_settings on Settings {
  announcement {
    id
    content
  }
}

fragment CommunityGuidelinesContainer_settings on Settings {
  communityGuidelines {
    enabled
    content
  }
}

fragment CreateCommentMutation_story on Story {
  id
  viewerRating {
    id
    tags {
      code
    }
    rating
  }
  settings {
    moderation
    mode
    live {
      enabled
    }
    experts {
      id
    }
  }
  ratings {
    count
    average
  }
}

fragment CreateCommentMutation_viewer on User {
  id
  avatar
  badges
  bio
  createdAt
  role
  username
  status {
    current
    ban {
      active
    }
  }
}

fragment CreateCommentReplyMutation_story on Story {
  settings {
    moderation
  }
}

fragment CreateCommentReplyMutation_viewer on User {
  role
  badges
  createdAt
  status {
    current
    ban {
      active
    }
  }
}

fragment MessageBoxContainer_story on Story {
  settings {
    messageBox {
      content
      icon
    }
    mode
  }
}

fragment ModerateStreamContainer_settings on Settings {
  auth {
    integrations {
      sso {
        enabled
        targetFilter {
          admin
        }
      }
    }
  }
}

fragment ModerateStreamContainer_story on Story {
  id
  canModerate
}

fragment ModerateStreamContainer_viewer on User {
  role
}

fragment PostCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  disableCommenting {
    enabled
    message
  }
  closeCommenting {
    message
  }
  media {
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    giphy {
      enabled
      key
      maxRating
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
}

fragment PostCommentFormContainer_story on Story {
  id
  isClosed
  site {
    id
  }
  viewerRating {
    id
    status
    tags {
      code
    }
    rating
  }
  settings {
    messageBox {
      enabled
    }
    experts {
      id
    }
    mode
  }
  ...MessageBoxContainer_story
}

fragment PostCommentFormContainer_viewer on User {
  id
  scheduledDeletionDate
}

fragment PreviousCountSpyContainer_settings on Settings {
  featureFlags
}

fragment PreviousCountSpyContainer_story on Story {
  id
  isClosed
  commentCounts {
    totalPublished
  }
}

fragment RTEContainer_config on RTEConfiguration {
  enabled
  strikethrough
  spoiler
  sarcasm
}

fragment StoryClosedTimeoutContainer_story on Story {
  id
  closedAt
}

fragment StoryRatingContainer_story on Story {
  id
  metadata {
    title
  }
  ratings {
    average
    count
  }
}

fragment StreamContainer_settings on Settings {
  reaction {
    sortLabel
  }
  featureFlags
  disableCommenting {
    enabled
  }
  ...AnnouncementContainer_settings
  ...CommunityGuidelinesContainer_settings
  ...ModerateStreamContainer_settings
  ...PostCommentFormContainer_settings
  ...PreviousCountSpyContainer_settings
  ...SuspendedInfoContainer_settings
  ...UserBoxContainer_settings
  ...ViewersWatchingContainer_settings
}

fragment StreamContainer_story on Story {
  id
  url
  isClosed
  settings {
    mode
  }
  commentCounts {
    totalPublished
    tags {
      FEATURED
      UNANSWERED
      REVIEW
      QUESTION
    }
  }
  ...CreateCommentMutation_story
  ...CreateCommentReplyMutation_story
  ...ModerateStreamContainer_story
  ...PostCommentFormContainer_story
  ...PreviousCountSpyContainer_story
  ...StoryClosedTimeoutContainer_story
  ...StoryRatingContainer_story
  ...ViewersWatchingContainer_story
}

fragment StreamContainer_viewer on User {
  id
  status {
    current
  }
  ...CreateCommentMutation_viewer
  ...CreateCommentReplyMutation_viewer
  ...ModerateStreamContainer_viewer
  ...PostCommentFormContainer_viewer
  ...StreamDeletionRequestCalloutContainer_viewer
  ...SuspendedInfoContainer_viewer
  ...UserBoxContainer_viewer
  ...WarningContainer_viewer
}

fragment StreamDeletionRequestCalloutContainer_viewer on User {
  scheduledDeletionDate
}

fragment SuspendedInfoContainer_settings on Settings {
  organization {
    name
  }
}

fragment SuspendedInfoContainer_viewer on User {
  status {
    suspension {
      until
    }
  }
}

fragment UserBoxContainer_settings on Settings {
  auth {
    integrations {
      local {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      oidc {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      google {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      facebook {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
    }
  }
}

fragment UserBoxContainer_viewer on User {
  username
}

fragment ViewersWatchingContainer_settings on Settings {
  disableCommenting {
    enabled
  }
}

fragment ViewersWatchingContainer_story on Story {
  id
  viewerCount
  isClosed
  settings {
    live {
      enabled
    }
  }
}

fragment WarningContainer_viewer on User {
  status {
    warning {
      active
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyID"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyMode"
    } as any), v2 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyURL"
    } as any), v3 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any),
        ({
            "kind": "Variable",
            "name": "mode",
            "variableName": "storyMode"
        } as any),
        ({
            "kind": "Variable",
            "name": "url",
            "variableName": "storyURL"
        } as any)
    ], v4 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v5 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "active",
        "storageKey": null
    } as any), v6 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any), v7 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
    } as any), v8 = [
        (v7 /*: any*/)
    ], v9 = [
        (v4 /*: any*/)
    ], v10 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "content",
        "storageKey": null
    } as any), v11 = [
        (v7 /*: any*/),
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowRegistration",
            "storageKey": null
        } as any),
        ({
            "alias": null,
            "args": null,
            "concreteType": "AuthenticationTargetFilter",
            "kind": "LinkedField",
            "name": "targetFilter",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stream",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "StreamQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "StreamContainer_viewer"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "story",
                    "args": (v3 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "stream",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "StreamContainer_story"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "StreamContainer_settings"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v2 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Operation",
            "name": "StreamQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "current",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BanStatus",
                                    "kind": "LinkedField",
                                    "name": "ban",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SuspensionStatus",
                                    "kind": "LinkedField",
                                    "name": "suspension",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "until",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WarningStatus",
                                    "kind": "LinkedField",
                                    "name": "warning",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        (v6 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "avatar",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "badges",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bio",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "username",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scheduledDeletionDate",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "story",
                    "args": (v3 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "stream",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isClosed",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorySettings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mode",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "moderation",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LiveConfiguration",
                                    "kind": "LinkedField",
                                    "name": "live",
                                    "plural": false,
                                    "selections": (v8 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "experts",
                                    "plural": true,
                                    "selections": (v9 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StoryMessageBox",
                                    "kind": "LinkedField",
                                    "name": "messageBox",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        (v10 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "icon",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentCounts",
                            "kind": "LinkedField",
                            "name": "commentCounts",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalPublished",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentTagCounts",
                                    "kind": "LinkedField",
                                    "name": "tags",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "FEATURED",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "UNANSWERED",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "REVIEW",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "QUESTION",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "viewerRating",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Tag",
                                    "kind": "LinkedField",
                                    "name": "tags",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "code",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "rating",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "status",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryRatings",
                            "kind": "LinkedField",
                            "name": "ratings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "count",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "average",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canModerate",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Site",
                            "kind": "LinkedField",
                            "name": "site",
                            "plural": false,
                            "selections": (v9 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "closedAt",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "viewerCount",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReactionConfiguration",
                            "kind": "LinkedField",
                            "name": "reaction",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sortLabel",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "featureFlags",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DisableCommenting",
                            "kind": "LinkedField",
                            "name": "disableCommenting",
                            "plural": false,
                            "selections": [
                                (v7 /*: any*/),
                                (v6 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Announcement",
                            "kind": "LinkedField",
                            "name": "announcement",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v10 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommunityGuidelines",
                            "kind": "LinkedField",
                            "name": "communityGuidelines",
                            "plural": false,
                            "selections": [
                                (v7 /*: any*/),
                                (v10 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Auth",
                            "kind": "LinkedField",
                            "name": "auth",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AuthIntegrations",
                                    "kind": "LinkedField",
                                    "name": "integrations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SSOAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "sso",
                                            "plural": false,
                                            "selections": [
                                                (v7 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AuthenticationTargetFilter",
                                                    "kind": "LinkedField",
                                                    "name": "targetFilter",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "admin",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "LocalAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "local",
                                            "plural": false,
                                            "selections": (v11 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OIDCAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "oidc",
                                            "plural": false,
                                            "selections": (v11 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "GoogleAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "google",
                                            "plural": false,
                                            "selections": (v11 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FacebookAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "facebook",
                                            "plural": false,
                                            "selections": (v11 /*: any*/),
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharCount",
                            "kind": "LinkedField",
                            "name": "charCount",
                            "plural": false,
                            "selections": [
                                (v7 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "min",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "max",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CloseCommenting",
                            "kind": "LinkedField",
                            "name": "closeCommenting",
                            "plural": false,
                            "selections": [
                                (v6 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaConfiguration",
                            "kind": "LinkedField",
                            "name": "media",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TwitterMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "twitter",
                                    "plural": false,
                                    "selections": (v8 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "YouTubeMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "youtube",
                                    "plural": false,
                                    "selections": (v8 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GiphyMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "giphy",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "key",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "maxRating",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ExternalMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "external",
                                    "plural": false,
                                    "selections": (v8 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "RTEConfiguration",
                            "kind": "LinkedField",
                            "name": "rte",
                            "plural": false,
                            "selections": [
                                (v7 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "strikethrough",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "spoiler",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sarcasm",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organization",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "a0240b387f7729780ee591b1d2736dae",
            "metadata": {},
            "name": "StreamQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '2ed26f680df400afeaf96cb901ca9eb2';
export default node;
